exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".user-avatar {\n  display: inline-block;\n  background-size: cover;\n  background-position: center;\n  border-radius: 100%; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /app/src/app/shared/components/user-avatar/user-avatar.scss
// module id = ../../../../../src/app/shared/components/user-avatar/user-avatar.scss
// module chunks = 12